import zElTableSize from './src/main.vue';
zElTableSize.install = (Vue) => {
	Vue.component(zElTableSize.name, zElTableSize);
};
export default zElTableSize;
